'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var navi_1 = require("./class/navi");
var login_1 = require("./class/login");
var to_next_section_1 = require("./class/to-next-section");
var survey_1 = require("./class/survey");
$(function () {
    new navi_1.default;
    new login_1.default;
    new to_next_section_1.default;
    new survey_1.default;
});
